"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useGridRowReorder = void 0;
var React = _interopRequireWildcard(require("react"));
var _composeClasses = _interopRequireDefault(require("@mui/utils/composeClasses"));
var _xDataGrid = require("@mui/x-data-grid");
var _internals = require("@mui/x-data-grid/internals");
var _gridRowReorderColDef = require("./gridRowReorderColDef");
var Direction = /*#__PURE__*/ function(Direction) {
    Direction[Direction["UP"] = 0] = "UP";
    Direction[Direction["DOWN"] = 1] = "DOWN";
    return Direction;
}(Direction || {});
var previousMousePosition = null;
var previousReorderState = {
    previousTargetId: null,
    dragDirection: null
};
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes;
    var slots = {
        rowDragging: [
            'row--dragging'
        ]
    };
    return (0, _composeClasses.default)(slots, _xDataGrid.getDataGridUtilityClass, classes);
};
/**
 * Only available in DataGridPro
 * @requires useGridRows (method)
 */ var useGridRowReorder = function(apiRef, props) {
    var logger = (0, _xDataGrid.useGridLogger)(apiRef, 'useGridRowReorder');
    var sortModel = (0, _xDataGrid.useGridSelector)(apiRef, _xDataGrid.gridSortModelSelector);
    var treeDepth = (0, _xDataGrid.useGridSelector)(apiRef, _xDataGrid.gridRowMaximumTreeDepthSelector);
    var dragRowNode = React.useRef(null);
    var originRowIndex = React.useRef(null);
    var removeDnDStylesTimeout = React.useRef(undefined);
    var ownerState = {
        classes: props.classes
    };
    var classes = useUtilityClasses(ownerState);
    var _React_useState = _sliced_to_array(React.useState(''), 2), dragRowId = _React_useState[0], setDragRowId = _React_useState[1];
    var sortedRowIndexLookup = (0, _xDataGrid.useGridSelector)(apiRef, _internals.gridSortedRowIndexLookupSelector);
    React.useEffect(function() {
        return function() {
            clearTimeout(removeDnDStylesTimeout.current);
        };
    }, []);
    // TODO: remove sortModel check once row reorder is sorting compatible
    // remove treeDepth once row reorder is tree compatible
    var isRowReorderDisabled = React.useMemo(function() {
        return !props.rowReordering || !!sortModel.length || treeDepth !== 1;
    }, [
        props.rowReordering,
        sortModel,
        treeDepth
    ]);
    var handleDragStart = React.useCallback(function(params, event) {
        // Call the gridEditRowsStateSelector directly to avoid infnite loop
        var editRowsState = (0, _internals.gridEditRowsStateSelector)(apiRef.current.state);
        if (isRowReorderDisabled || Object.keys(editRowsState).length !== 0) {
            return;
        }
        logger.debug("Start dragging row ".concat(params.id));
        // Prevent drag events propagation.
        // For more information check here https://github.com/mui/mui-x/issues/2680.
        event.stopPropagation();
        dragRowNode.current = event.currentTarget;
        dragRowNode.current.classList.add(classes.rowDragging);
        setDragRowId(params.id);
        removeDnDStylesTimeout.current = setTimeout(function() {
            dragRowNode.current.classList.remove(classes.rowDragging);
        });
        originRowIndex.current = sortedRowIndexLookup[params.id];
        apiRef.current.setCellFocus(params.id, _gridRowReorderColDef.GRID_REORDER_COL_DEF.field);
    }, [
        apiRef,
        isRowReorderDisabled,
        logger,
        classes.rowDragging,
        sortedRowIndexLookup
    ]);
    var handleDragOver = React.useCallback(function(params, event) {
        if (dragRowId === '') {
            return;
        }
        var rowNode = apiRef.current.getRowNode(params.id);
        if (!rowNode || rowNode.type === 'footer' || rowNode.type === 'pinnedRow') {
            return;
        }
        logger.debug("Dragging over row ".concat(params.id));
        event.preventDefault();
        // Prevent drag events propagation.
        // For more information check here https://github.com/mui/mui-x/issues/2680.
        event.stopPropagation();
        var mouseMovementDiff = previousMousePosition ? previousMousePosition.y - event.clientY : event.clientY;
        if (params.id !== dragRowId) {
            var targetRowIndex = sortedRowIndexLookup[params.id];
            var dragDirection = mouseMovementDiff > 0 ? Direction.DOWN : Direction.UP;
            var currentReorderState = {
                dragDirection: dragDirection,
                previousTargetId: params.id
            };
            var isStateChanged = currentReorderState.dragDirection !== previousReorderState.dragDirection || currentReorderState.previousTargetId !== previousReorderState.previousTargetId;
            if (previousReorderState.dragDirection === null || Math.abs(mouseMovementDiff) >= 1 && isStateChanged) {
                apiRef.current.setRowIndex(dragRowId, targetRowIndex);
                previousReorderState = currentReorderState;
            }
        }
        previousMousePosition = {
            x: event.clientX,
            y: event.clientY
        };
    }, [
        dragRowId,
        apiRef,
        logger,
        sortedRowIndexLookup
    ]);
    var handleDragEnd = React.useCallback(function(params, event) {
        // Call the gridEditRowsStateSelector directly to avoid infnite loop
        var editRowsState = (0, _internals.gridEditRowsStateSelector)(apiRef.current.state);
        if (dragRowId === '' || isRowReorderDisabled || Object.keys(editRowsState).length !== 0) {
            return;
        }
        logger.debug('End dragging row');
        event.preventDefault();
        // Prevent drag events propagation.
        // For more information check here https://github.com/mui/mui-x/issues/2680.
        event.stopPropagation();
        clearTimeout(removeDnDStylesTimeout.current);
        dragRowNode.current = null;
        previousReorderState.dragDirection = null;
        // Check if the row was dropped outside the grid.
        if (event.dataTransfer.dropEffect === 'none') {
            // Accessing params.field may contain the wrong field as header elements are reused
            apiRef.current.setRowIndex(dragRowId, originRowIndex.current);
            originRowIndex.current = null;
        } else {
            // Emit the rowOrderChange event only once when the reordering stops.
            var rowOrderChangeParams = {
                row: apiRef.current.getRow(dragRowId),
                targetIndex: sortedRowIndexLookup[params.id],
                oldIndex: originRowIndex.current
            };
            apiRef.current.publishEvent('rowOrderChange', rowOrderChangeParams);
        }
        setDragRowId('');
    }, [
        apiRef,
        dragRowId,
        isRowReorderDisabled,
        logger,
        sortedRowIndexLookup
    ]);
    (0, _xDataGrid.useGridApiEventHandler)(apiRef, 'rowDragStart', handleDragStart);
    (0, _xDataGrid.useGridApiEventHandler)(apiRef, 'rowDragOver', handleDragOver);
    (0, _xDataGrid.useGridApiEventHandler)(apiRef, 'rowDragEnd', handleDragEnd);
    (0, _xDataGrid.useGridApiEventHandler)(apiRef, 'cellDragOver', handleDragOver);
    (0, _xDataGrid.useGridApiOptionHandler)(apiRef, 'rowOrderChange', props.onRowOrderChange);
};
exports.useGridRowReorder = useGridRowReorder;
